import AssetAttribute from "../../../model/assetAttribute/AssetAttribute";

/**
 * Fetch asset attributes successful action.
 */
export const ASSET_ATTRIBUTES_FETCHED = "ASSET_ATTRIBUTES_FETCHED";
export type ASSET_ATTRIBUTES_FETCHED = { assetAttributes: Array<AssetAttribute> }